<template>
	<!-- TODO 出庫予定日を記入するフォームを追加する -->
	<v-sheet :tile="$vuetify.breakpoint.xs">
		<FunctionTitle title="" />
		<CommonFlame :title="title" class="mt-2">
			<div :class="{ 'flex-container': showFlex }">
				<div :class="{ fixed: showFixed }">
					<v-menu
						ref="menu"
						v-model="calendar"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								readonly
								outlined
								dense
								v-model="order_date"
								:hint="
									order_date
										? '下書きの場合は注文日は保存されません'
										: '設定しない場合は本日の日付が入力されます'
								"
								persistent-hint
								label="注文日"
								v-bind="attrs"
								v-on="on"
								class="px-4 mt-4"
								@click="calendar = true"
							/>
						</template>
						<v-date-picker
							v-model="order_date"
							no-title
							scrollable
							@input="calendar = false"
							locale="ja"
						>
						</v-date-picker>
					</v-menu>
					<v-combobox
						ref="combobox"
						label="発注先を探す(必須)"
						item-text="name"
						item-value="id"
						outlined
						dense
						v-model="supplier"
						@keyup="setSearchSupplier"
						@change="changeRegularCustomer"
						:items="suppliers"
						no-data-text="選択肢がありません"
						:rules="[rules.required]"
						class="px-4 mt-4"
					/>

					<v-text-field
						label="発注先担当者"
						class="px-4 mt-4"
						hint="発注先を選択すると自動入力されます"
						outlined
						required
						dense
						v-model="supplierPerson"
						:rules="[rules.required]"
					>
					</v-text-field>
					<v-text-field
						label="発注先メールアドレス"
						hint="発注先を選択すると自動入力されます"
						class="px-4 mt-4"
						outlined
						required
						dense
						v-model="supplierEmail"
						:rules="[rules.required]"
					>
					</v-text-field>
					<DragUpload @fileShare="fileShare" class="input" />
					<div
						v-for="file in order_data.return_all_attached_file_infos"
						:key="file.id"
						class="mx-2"
					>
						<a
							v-if="!file.destroy_flag && order_data.status_type == 'draft'"
							:href="file.url"
							target="_blank"
							>{{ file.name }}</a
						><v-icon
							@click="openDeleteFileConfirmation(file.id)"
							v-if="!file.destroy_flag && order_data.status_type == 'draft'"
							>mdi-delete</v-icon
						>
					</div>
				</div>
				<div :class="{ scroll: showScroll }">
					<v-form class="pa-2" ref="form" v-model="valid">
						<div
							v-for="(order_data_component, index) in order_data_components"
							:key="order_data_component.id"
							class="mb-2 order-component"
						>
							<h3 class="component-index">
								{{ `注文部品　#${index + 1}` }}
								<v-btn @click="removeOrderComponent(index)" icon color="secondary"
									><v-icon>mdi-delete</v-icon></v-btn
								>
							</h3>
							<h3
								v-if="
									order_data_component &&
									order_data_component.order_component &&
									order_data_component.order_component.ordered_product
								"
							>
								製造番号：{{ order_data_component.order_component.ordered_product.product_number }}
							</h3>
							<h3 v-else-if="product_number">製造番号：{{ product_number }}</h3>
							<div>
								<v-text-field
									label="部品名(必須)"
									class="mt-4"
									outlined
									dense
									v-model="order_data_component.component_name"
									:rules="[rules.required]"
								></v-text-field>
							</div>
							<v-text-field
								label="発注単価(必須)"
								hint="半角数字で入力してください"
								class="mt-2"
								outlined
								dense
								v-model="order_data_component.unit_price"
								:rules="[rules.integer, rules.required]"
							>
							</v-text-field>
							<p class="mb-8" v-if="order_data_component.unit_price">
								{{
									isNaN(order_data_component.unit_price)
										? ""
										: Number(order_data_component.unit_price).toLocaleString("ja-JP") + "円"
								}}
							</p>
							<v-text-field
								label="発注数量(必須)"
								class="mt-2"
								hint="半角数字で入力してください"
								outlined
								dense
								v-model="order_data_component.quantity"
								:rules="[rules.integer, rules.required]"
							>
							</v-text-field>
							<v-textarea
								type="text"
								class="mt-2"
								label="仕様"
								outlined
								dense
								v-model="order_data_component.remarks"
							/>

							<v-menu
								ref="menu"
								v-model="menu[index]"
								:close-on-content-click="false"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-text-field
										readonly
										outlined
										dense
										v-model="order_data_component.expected_receiving_date"
										label="納期(必須)"
										v-bind="attrs"
										v-on="on"
										:rules="[rules.required]"
										@click="menu[index] = true"
									/>
								</template>
								<v-date-picker
									v-model="order_data_component.expected_receiving_date"
									no-title
									scrollable
									@input="menu[index] = false"
									locale="ja"
								>
								</v-date-picker>
							</v-menu>
						</div>
					</v-form>
				</div>
			</div>
			<div>
				<v-row no-gutters justify="end">
					<v-btn v-if="!componentFlag" @click="openAddOrderComponentDialog()">
						<v-icon>mdi-plus</v-icon>注文部品追加</v-btn
					>
					<v-btn v-if="componentFlag" @click="openSearchComponentDialog()">
						<v-icon>mdi-plus</v-icon>注文部品追加</v-btn
					>
				</v-row>
			</div>

			<v-card-actions class="mt-8">
				<v-row justify="center">
					<v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 8">
						<v-btn
							v-if="this.order_data_components.length > 0"
							color="secondary"
							@click="openCreateDialog()"
							:disabled="!valid || isComponentDateEmpty()"
							block
						>
							注文書作成
						</v-btn>
					</v-col>

					<v-col :cols="$vuetify.breakpoint.mdAndUp ? 4 : 8">
						<v-btn
							v-if="this.order_data_components.length > 0"
							color="primary"
							@click="openDraftDialog()"
							block
						>
							下書き保存
						</v-btn>
					</v-col>
					<v-col
						v-if="order_data_components.length > 0 && order_data.status_type == 'draft'"
						:cols="$vuetify.breakpoint.mdAndUp ? 4 : 8"
					>
						<v-btn color="red" @click="openDeleteDialog()" block dark> 下書き削除 </v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</CommonFlame>
		<OrderDataConfirmationDialog
			:dialogTitle="dialogTitle"
			:dialogContent="dialogContent"
			:createFlag="createFlag"
			:onlyDataFlag="onlyDataFlag"
			:deleteFlag="deleteFlag"
			:draftFlag="draftFlag"
			:fileDeleteFlag="fileDeleteFlag"
			:dialog.sync="confirmationDialog"
			@resetBtnFlag="closeDialog"
			@createOrderDataDraft="saveDraft"
			@createOrderData="updateOrderData"
			@deleteDraft="deleteDraft"
			@deleteFile="deleteFile"
		/>
		<AddComponentDialog
			:dialog.sync="addDialog"
			:order_components="order_components"
			@add-component="addOrderComponent"
		/>
		<SearchComponentDialog
			:dialog.sync="searchDialog"
			:order_components="order_components"
			@select-components="addComponents"
		/>
	</v-sheet>
</template>

<script>
import _ from "lodash"
import rules from "../../helper/rules"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import common from "../../helper/common"
import AddComponentDialog from "./component/AddComponentDialog.vue"
import SearchOrderComponentDialog from "./component/SearchOrderComponentDialog.vue"
import SearchComponentDialog from "./component/SearchComponentDialog.vue"
import OrderDataConfirmationDialog from "./component/OrderDataConfirmationDialog.vue"
import DragUpload from "../shared/DragUpload.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		SearchOrderComponentDialog,
		AddComponentDialog,
		SearchComponentDialog,
		OrderDataConfirmationDialog,
		DragUpload,
	},
	props: {},
	data() {
		return {
			title: "内容変更",
			valid: false,
			order_date: "",
			searchDialog: false,
			addDialog: false,
			componentDialog: false,
			confirmationDialog: false,
			dialog: false,
			menu: [],
			date: "",
			calendar: false,
			unit_price: "",
			remarks: "",
			quantity: "",
			component_name: "",
			supplier: "",
			suppliers: [],
			supplierPersons: [],
			supplierPerson: "",
			supplierEmail: "",
			supplierId: "",
			components: [],
			supplierPerson: "",
			order_component_id: "",
			form_type: "",
			searchProductNumber: "",
			searchMatterName: "",
			order_components: [],
			original_order_data_components: [],
			common: common,
			displayBtn: false,
			rules: rules,
			orderComponent: {},
			componentFlag: false,
			order_data_id: this.$route.query.order_data_id,
			order_data_components: [],
			order_data_component: {
				order_component: {
					component: {},
				},
			},
			order_data: {},
			dialogTitle: "",
			dialogContent: "",
			showFlex: false,
			showScroll: false,
			showFixed: false,
			createFlag: false,
			onlyDataFlag: false,
			draftFlag: false,
			deleteFlag: false,
			fileDeleteFlag: false,
			order_components: [],
			return_all_attached_file_infos: [],
			received_flag: false,
		}
	},

	mounted() {
		this.fetchOrderComponents()
	},

	methods: {
		closeDialog() {
			this.draftFlag = false
			this.createFlag = false
			this.onlyDataFlag = false
			this.deleteFlag = false
			this.fileDeleteFlag = false
		},

		isComponentDateEmpty() {
			return this.order_data_components.some((order_component) => {
				return (
					order_component.expected_receiving_date == null ||
					order_component.quantity == null ||
					order_component.unit_price == null
				)
			})
		},
		fetchOrderComponents() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/order_data/order_data/${this.order_data_id}/edit`, {
					headers,
				})
				.then((res) => {
					this.order_data = res.data.order_data
					this.product_number = res.data.product_number
					this.order_data.return_all_attached_file_infos =
						res.data.order_data.return_all_attached_file_infos
					if (
						res.data.order_data.order_data_components[0].order_component &&
						res.data.order_data.order_data_components[0].order_component.ordered_product
					) {
						this.order_components =
							res.data.order_data.order_data_components[0].order_component.ordered_product.order_components
					} else if (
						res.data.order_data.order_data_components[0].order_component &&
						res.data.order_data.order_data_components[0].order_component.matter_product
					) {
						this.order_components =
							res.data.order_data.order_data_components[0].order_component.matter_product.order_components
					} else {
						this.order_components = res.data.order_data.order_data_components
						this.componentFlag = true
					}

					this.order_data_components = res.data.order_data.order_data_components

					if (this.order_data.status_type === "sent") {
						this.order_data_components.forEach((component) => {
							component.expected_receiving_date = null
						})
					}

					this.showFlex = true
					this.showScroll = true
					this.showFixed = true

					this.supplier = res.data.order_data.supplier
					this.supplierEmail = res.data.order_data.supplier.email
					this.supplierPerson = res.data.order_data.supplier.pic_name
					this.order_date = res.data.order_data.order_date
					if (this.order_data.status_type != "draft") {
						this.title = "発注済み内容変更"
					} else {
						this.title = "注文データ作成"
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		setSearchSupplier(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.suppliers = []
			this.supplierKeyword = e.target.value
			clearTimeout(this.searchSupplierTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.supplierKeyword.length) return // 0文字の場合はreturn
			this.searchSupplierTimer = setTimeout(this.searchSupplier, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		searchSupplier() {
			const params = {
				q: {
					name_cont: this.supplierKeyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/order_data/search_suppliers", {
					headers,
					params,
				})
				.then((res) => {
					this.suppliers = res.data.suppliers
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		changeRegularCustomer() {
			if (!this.suppliers.includes(this.supplier)) {
				this.errorSupplierFlag = true
				this.supplier = null
				this.$refs.combobox.reset()
			}
			this.supplierPerson = ""
			this.supplierEmail = ""
			if (this.supplier) {
				this.supplierPerson = this.supplier.pic_name
				this.supplierEmail = this.supplier.email
			}
		},

		updateOrderData(status_type = "sent") {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			formData.append("supplier_id", this.supplier.id)
			formData.append("order_date", this.order_date)
			formData.append("status_type", status_type)

			this.order_data_components.forEach((order_component) => {
				if (order_component.remarks === null || order_component.remarks === undefined) {
					order_component.remarks = ""
				}
			})
			this.order_data_components.forEach((order_data_component, index) => {
				formData.append(
					`order_data_components[${index}][name]`,
					order_data_component.component_name
				)
				formData.append(`order_data_components[${index}][quantity]`, order_data_component.quantity)
				formData.append(
					`order_data_components[${index}][unit_price]`,
					order_data_component.unit_price
				)
				formData.append(`order_data_components[${index}][remarks]`, order_data_component.remarks)
				formData.append(
					`order_data_components[${index}][date]`,
					order_data_component.expected_receiving_date
				)

				formData.append(
					`order_data_components[${index}][order_data_component_id]`,
					order_data_component.id
				)

				if (
					order_data_component &&
					order_data_component.order_component &&
					order_data_component.order_component.component.id
				) {
					formData.append(
						`order_data_components[${index}][component_id]`,
						order_data_component.order_component.component.id
					)
				} else if (order_data_component.component) {
					formData.append(
						`order_data_components[${index}][component_id]`,
						order_data_component.component.id
					)
				} else {
					// 部品を追加した時のcomponent_id
					formData.append(`order_data_components[${index}][component_id]`, this.componentId)
				}

				if (order_data_component.order_component) {
					formData.append(
						`order_data_components[${index}][order_component_id]`,
						order_data_component.order_component.id
					)
				}
			})

			if (this.order_data.unsheduled_flag == false) {
				axios
					.put(`/erp/v1/order_data/order_data/${this.order_data_id}`, formData, { headers })
					.then((res) => {
						this.order_data_id = res.data.order_data_id
						this.situation = res.data.situation

						if (this.situation == "received") {
							this.$store.commit("setFlash", {
								text: "注文データを作成しました。すでに入庫済みの部品が含まれています。在庫表の入庫数は直接変更してください。",
								type: "notice",
							})
						} else if (this.situation == "planned") {
							this.$store.commit("setFlash", {
								text: "注文データを作成して、在庫表の入庫数を変更しました。",
								type: "notice",
							})
						}

						if (this.uploadFiles) {
							this.uploadFiles.forEach((file) => {
								this.fileUpload(file, this.order_data_id)
							})
						}

						this.$router.push({
							name: "order_data_purchase_order",
							params: { id: this.order_data_id },
						})
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				axios
					.put(
						`/erp/v1/component_procurement_requirements/component_procurement_order_data/${this.order_data_id}`,
						formData,
						{ headers }
					)
					.then((res) => {
						this.order_data_id = res.data.order_data_id
						this.situation = res.data.situation

						if (this.situation == "received") {
							this.$store.commit("setFlash", {
								text: "注文データを作成しました。すでに入庫済みの部品が含まれています。在庫表の入庫数は直接変更してください。",
								type: "notice",
							})
						} else if (this.situation == "planned") {
							this.$store.commit("setFlash", {
								text: "注文データを作成して、在庫表の入庫数を変更しました。",
								type: "notice",
							})
						}

						if (this.uploadFiles) {
							this.uploadFiles.forEach((file) => {
								this.fileUpload(file, this.order_data_id)
							})
						}

						this.$router.push({
							name: "order_data_purchase_order",
							params: { id: this.order_data_id },
						})
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			}
		},

		updateOnlyData(status_type = "sent") {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			this.order_data_components.forEach((order_component) => {
				if (order_component.remarks === null || order_component.remarks === undefined) {
					order_component.remarks = ""
				}
			})
			formData.append("status_type", status_type)
			formData.append("supplier_id", this.supplier.id)
			formData.append("order_date", this.order_date)
			this.order_data_components.forEach((order_data_component, index) => {
				formData.append(
					`order_data_components[${index}][name]`,
					order_data_component.component_name
				)
				formData.append(`order_data_components[${index}][quantity]`, order_data_component.quantity)
				formData.append(
					`order_data_components[${index}][unit_price]`,
					order_data_component.unit_price
				)
				formData.append(`order_data_components[${index}][remarks]`, order_data_component.remarks)
				formData.append(
					`order_data_components[${index}][date]`,
					order_data_component.expected_receiving_date
				)
				formData.append(
					`order_data_components[${index}][order_data_component_id]`,
					order_data_component.id
				)

				if (order_data_component.order_component) {
					formData.append(
						`order_data_components[${index}][order_component_id]`,
						order_data_component.order_component.id
					)
				}
				if (order_data_component.component) {
					formData.append(
						`order_data_components[${index}][component_id]`,
						order_data_component.component.id
					)
				}
			})

			axios
				.put(`/erp/v1/order_data/order_data/${this.order_data_id}`, formData, { headers })
				.then((res) => {
					this.order_data_id = res.data.order_data_id
					this.situation = res.data.situation
					if (this.situation == "received") {
						this.$store.commit("setFlash", {
							text: "注文データを作成しました。※すでに入庫済みの部品が含まれています。在庫表の入庫数は直接変更してください。",
							type: "notice",
						})
					} else if (this.situation == "planned") {
						this.$store.commit("setFlash", {
							text: "注文データを作成して在庫表の入庫数を変更しました。",
							type: "notice",
						})
					}
					if (this.uploadFiles) {
						this.uploadFiles.forEach((file) => {
							this.fileUpload(file, this.order_data_id)
						})
					}
					this.$router.push({
						name: "order_data",
						params: { id: this.order_data_id },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		saveDraft() {
			if (this.order_data.status_type === "sent") {
				this.updateOnlyData("draft")
			} else {
				const headers = authenticate.setHeader()
				const formData = new FormData()
				this.order_data_components.forEach((order_component) => {
					if (order_component.remarks === null || order_component.remarks === undefined) {
						order_component.remarks = ""
					}
				})
				formData.append("supplier_id", this.supplier.id)
				formData.append("order_date", this.order_date)

				this.order_data_components.forEach((order_data_component, index) => {
					formData.append(
						`order_data_components[${index}][name]`,
						order_data_component.component_name
					)
					formData.append(
						`order_data_components[${index}][quantity]`,
						order_data_component.quantity
					)
					formData.append(
						`order_data_components[${index}][unit_price]`,
						order_data_component.unit_price
					)
					formData.append(`order_data_components[${index}][remarks]`, order_data_component.remarks)
					formData.append(
						`order_data_components[${index}][expected_receiving_date]`,
						order_data_component.expected_receiving_date
					)
					formData.append(
						`order_data_components[${index}][order_data_component_id]`,
						order_data_component.id
					)
					if (
						order_data_component &&
						order_data_component.order_component &&
						order_data_component.order_component.component.id
					) {
						formData.append(
							`order_data_components[${index}][component_id]`,
							order_data_component.order_component.component.id
						)
					} else if (order_data_component.component) {
						formData.append(
							`order_data_components[${index}][component_id]`,
							order_data_component.component.id
						)
					} else {
						formData.append(`order_data_components[${index}][component_id]`, this.componentId)
					}

					if (order_data_component.order_component) {
						formData.append(
							`order_data_components[${index}][order_component_id]`,
							order_data_component.order_component.id
						)
					}
				})

				axios
					.put(`/erp/v1/order_data/order_data_draft/${this.order_data_id}`, formData, { headers })
					.then((res) => {
						this.order_data_id = res.data.order_data_id
						this.$store.commit("setFlash", {
							text: "下書き保存しました。",
							type: "notice",
						})
						if (this.uploadFiles) {
							this.uploadFiles.forEach((file) => {
								this.fileUpload(file, this.order_data_id)
							})
						}
						this.$router.push({ name: "order_data" })
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			}
		},

		deleteDraft() {
			const headers = authenticate.setHeader()
			if (this.order_data.unsheduled_flag) {
				axios
					.delete(`/erp/v1/order_data/order_data_draft/${this.order_data_id}`, { headers })
					.then((res) => {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "下書きを削除しました。",
						})
						this.$router.push({ name: "order_data" })
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				axios
					.delete(
						`/erp/v1/component_procurement_requirements/component_procurement_order_data_draft/${this.order_data_id}`,
						{ headers }
					)
					.then((res) => {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "下書きを削除しました。",
						})
						this.$router.push({ name: "order_data" })
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			}
		},

		isPresence(value) {
			return value !== null && value !== ""
		},
		fileShare(files) {
			this.uploadFiles = files
		},
		removeOrderComponent(index) {
			this.order_data_components.splice(index, 1)
		},
		openSearchComponentDialog() {
			this.searchDialog = true
		},
		openAddOrderComponentDialog() {
			this.addDialog = true
		},
		addOrderComponent(orderComponent) {
			orderComponent.id = null
			orderComponent.component_name = orderComponent.component.name
			this.order_data_components.push(orderComponent)
		},

		addComponents(components) {
			components.forEach((component) => {
				this.componentId = component.id
				component.id = null
				component.component_name = component.name
				this.order_data_components.push(component)
			})
		},

		openDraftDialog() {
			this.confirmationDialog = true
			this.draftFlag = true
			this.dialogContent = "下書き保存します。よろしいですか？"
			this.dialogTitle = "下書き保存"
		},

		openCreateDialog() {
			this.confirmationDialog = true
			this.createFlag = true
			if (this.order_data.status_type == "sent") {
				this.dialogTitle = "注文データ内容変更"
				this.dialogContent = `注文データを作成して、注文書ページへ遷移します。\n・注文部品が未入荷の場合は在庫表の入庫個数は自動で変更されます。\n・注文部品がすでに入庫済みの場合は在庫表は自動変更されません。入庫個数の変更は直接在庫表で変更してください。`
			} else {
				this.dialogTitle = "注文データ作成"
				this.dialogContent = `注文データを作成して、注文書ページへ遷移します。\n・注文部品が未入荷の場合は在庫表の入庫個数は自動で変更されます。\n・注文部品がすでに入庫済みの場合は在庫表は自動変更されません。入庫個数の変更は直接在庫表で変更してください。`
			}
		},

		openDeleteDialog() {
			this.confirmationDialog = true
			this.deleteFlag = true
			this.dialogTitle = "下書き削除"
			this.dialogContent = "下書きを削除します。よろしいですか？"
		},

		openDeleteFileConfirmation(file_id) {
			this.file_id = file_id
			this.confirmationDialog = true
			this.fileDeleteFlag = true
			this.dialogTitle = "ファイル削除"
			this.dialogContent = "ファイルを削除します。よろしいですか？"
		},

		fileUpload(file, order_data_id) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("order_data_id", order_data_id)
			formData.append("file", file)
			axios
				.post("/erp/v1/order_data/files", formData, { headers })
				.then((res) => {
					if (!res.data.no_error) {
						this.$store.dispatch("setFlash", {
							text: res.data.miss_file + "の作成に失敗しました",
							type: "alert",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		deleteFile() {
			const headers = authenticate.setHeader()

			axios
				.delete(`/erp/v1/order_data/files/${this.file_id}`, {
					headers,
				})
				.then((res) => {
					this.order_data.return_all_attached_file_infos = res.data.return_all_attached_file_infos
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>
<style lang="scss" scoped>
.component-index {
	font-size: 20px;
	font-weight: bold;
	display: flex;
	align-items: center;
}
.order-component {
	border: solid 2px;
	padding: 20px;
}

.flex-container {
	display: flex;
}
.flex-item {
	padding: 10px;
}
.scroll {
	flex-basis: 60%;
	overflow-y: auto;
	height: 600px;
}
.fixed {
	position: sticky;
	left: 0;
	top: 0;
	z-index: 1;
	flex-basis: 40%;
}

@media screen and (max-width: 650px) {
	.flex-container {
		display: block;
	}
	.scroll {
		margin-top: 20px;
		height: auto;
	}
}
</style>
